import { useMemo } from "react"

import { useBounceGlobalValues, useDisplayRegionName, useLocale } from "@bounce/i18n"

import { useCityPriceInterpolations } from "../../CityScreen/hooks/useCityPriceInterpolations"
import type { BasePoiInterpolations } from "../utils/getPoiInterpolations"
import { getBasePoiInterpolations } from "../utils/getPoiInterpolations"
import type { PoiData } from "@/libs/bounce/pois"
import { useUrl } from "@/libs/router"
import { useAppURL } from "@/utils/appURL"

export type Interpolations = BasePoiInterpolations & {
  MOBILE_DOWNLOAD_URL: string
  SEARCH_URL: string
}

export const useInterpolations = ({ poi }: { poi: PoiData }): Interpolations => {
  const displayRegionName = useDisplayRegionName()
  const priceInterpolations = useCityPriceInterpolations(poi.city)
  const { language } = useLocale()
  const bounceGlobals = useBounceGlobalValues({ currency: priceInterpolations.currency })
  const { getUrl } = useUrl()
  const buildAppURL = useAppURL()

  const searchUrl = buildAppURL(getUrl({ path: "/s" }), { query: poi.query })

  const interpolations = useMemo(
    () => ({
      ...getBasePoiInterpolations({
        poi,
        language,
        bounceGlobals,
        displayRegionName,
        priceInterpolations,
      }),
      MOBILE_DOWNLOAD_URL: getUrl({ path: "#appDownload" }),
      SEARCH_URL: searchUrl,
    }),
    [poi, language, bounceGlobals, displayRegionName, priceInterpolations, getUrl, searchUrl],
  )

  return interpolations
}
